
import React from "react";
import { Schemes, Utils } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Elements } from "../../../shared/Elements";
import { ConfirmDialog, Siren } from "../../../shared/ConfirmDialog";
import { BoolHelper, Button, ButtonManageRef, Checkbox, Classname, Form, FormControl, Scheme, TextAreaInput, TextInput } from "@rivtn/noseur";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { ApiResponseData, BaseService, ConsusService, IMember, IProfileWebsite, ITeam, ITeamMember, ITeamWebsite, IUploadedFile, MemberService, SanitizedResponse, TeamMemberStatus, TeamRole, TeamService } from "../../../../services";
import MediaInput from "../../../shared/MediaInput";

export interface MembersProps {
    team: ITeam;
    profile: IMember;
    teamWebsite: ITeamWebsite;
}

function Members(props: MembersProps) {

    const { team } = props;
    const teamService = TeamService.getInstance();
    const consusService = ConsusService.getInstance();
    const [init, setInit] = React.useState<boolean>(false);
    const labels = i18nManager.Labels.teams.settings.members;
    const [selectedTeamMember, setSelectedTeamMember] = React.useState<ITeamMember>();
    const [teamWebsite, setTeamWebsite] = React.useState<ITeamWebsite>(props.teamWebsite);
    const [teamMembers, setTeamMembers] = React.useState<ApiResponseData<ITeamMember>>({});
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);

    React.useEffect(() => {
        fetchInformation();

        return () => {
            Utils.updateSearchParams("stmid", null, setSearchParams);
        };
    }, []);

    React.useEffect(() => {
        if (!init) {
            setInit(true);
            return;
        }
        updateTeamWebsite();
    }, [teamWebsite]);

    if (!selectedTeamMember) return renderListing();

    return (<div className="profile-settings team-settings">
        {!teamMembers.content ? (Elements.LOADING_STATE) : (<div className="tmems-details">
            <div>
                <div className="tmems-list">
                    {teamMembers.content.map((teamMember) => {
                        return (<div key={teamMember.external_id} className={Classname.build("tmems-l", { "active": teamMember.external_id === selectedTeamMember?.external_id })} onClick={() => {
                            Utils.updateSearchParams("stmid", teamMember.external_id, setSearchParams, () => {
                                setSelectedTeamMember(undefined);
                                setTimeout(() => setSelectedTeamMember({ ...teamMember }), 100);
                            });
                        }}>
                            <img alt={teamMember.display_name} src={teamMember.passport_picture_url} />
                        </div>);
                    })}
                </div>
                <span className="link" onClick={() => {
                    Utils.updateSearchParams("stmid", null, setSearchParams, () => setSelectedTeamMember(undefined));
                }}>{i18nManager.Labels.common.close}</span>
            </div>
            <div className="tmem-detail">
                <div>
                    <div>
                        <MediaInput style={{ marginBottom: 0, flex: 1 }} width={"100%"} height={300} maxWidth={420}
                            noFillTemplate default={selectedTeamMember.half_body_picture_url} onSelectFiles={(files) => {
                                consusService.uploadFile("/omnehost/team/member/", `half_body_${selectedTeamMember?.external_id}`, files[0]).then(({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                                    setSelectedTeamMember({ ...selectedTeamMember, half_body_picture_url: sanitized.consus_download_url });
                                    updateTeamMember({ ...selectedTeamMember, half_body_picture_url: sanitized.consus_download_url });
                                }).catch(BaseService.reportError);
                            }} onGenerateWithAi={async () => {
                                return new File(["We are here"], "we.txt", { type: 'text/plain' });
                            }} />
                        <FormControl isFieldset fill label={labels.role} style={{ marginTop: 15 }} rightContent={<i className="fa fa-star" />}>
                            <TextInput defaultValue={selectedTeamMember.extra_data?.team_role} fill onInputComplete={(value: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, team_role: value } as any);
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.member.twitch} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedTeamMember.social_accounts["twitch"]} fill onInputComplete={(twitch: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, social_accounts: { ...selectedTeamMember.social_accounts, twitch } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.member.instagram} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedTeamMember.social_accounts["instagram"]} fill onInputComplete={(instagram: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, social_accounts: { ...selectedTeamMember.social_accounts, instagram } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.member.twitter_x} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedTeamMember.social_accounts["twitter_x"]} fill onInputComplete={(twitter_x: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, social_accounts: { ...selectedTeamMember.social_accounts, twitter_x } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.member.youtube} style={{ marginTop: 15 }} rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                            console.log("Get Profile account")
                        }} />}>
                            <TextInput defaultValue={selectedTeamMember.social_accounts["youtube"]} fill onInputComplete={(youtube: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, social_accounts: { ...selectedTeamMember.social_accounts, youtube } });
                            }} />
                        </FormControl>
                    </div>
                    <div>
                        <MediaInput style={{ marginBottom: 0 }} width={190} height={190}
                            noFillTemplate default={selectedTeamMember.passport_picture_url} onSelectFiles={(files) => {
                                consusService.uploadFile("/omnehost/team/member/", `passport_${selectedTeamMember?.external_id}`, files[0]).then(({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                                    setSelectedTeamMember({ ...selectedTeamMember, passport_picture_url: sanitized.consus_download_url });
                                    updateTeamMember({ ...selectedTeamMember, passport_picture_url: sanitized.consus_download_url });
                                }).catch(BaseService.reportError);
                            }} onGenerateWithAi={async () => {
                                return new File(["We are here"], "we.txt", { type: 'text/plain' });
                            }} />
                        <FormControl isFieldset fill label={labels.member.display_name} style={{ marginTop: 15 }}
                            rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                                console.log("Get Profile account")
                            }} />}>
                            <TextInput defaultValue={selectedTeamMember.display_name} fill onInputComplete={(value: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, display_name: value });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.member.profile_description} style={{ marginTop: 15 }}
                            rightContent={<i className="fa fa-user" style={{ cursor: "pointer " }} onClick={() => {
                                console.log("Get Profile account")
                            }} />}>
                            <TextAreaInput style={{ height: 200 }} defaultValue={selectedTeamMember.profile_details} fill onInputComplete={(value: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, profile_details: value });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.member.country} style={{ marginTop: 15 }} >
                            <TextInput defaultValue={selectedTeamMember.settings.country} fill onInputComplete={(country: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, settings: { ...selectedTeamMember.settings, country } });
                            }} />
                        </FormControl>
                        <FormControl isFieldset fill label={labels.member.state_region} style={{ marginTop: 15 }} >
                            <TextInput defaultValue={selectedTeamMember.settings.state_region} fill onInputComplete={(state_region: string) => {
                                setSelectedTeamMember({ ...selectedTeamMember, settings: { ...selectedTeamMember.settings, state_region } });
                            }} />
                        </FormControl>
                        <Checkbox scheme={Schemes.OMNEHOST} label={labels.member.hide_from_mem_page} style={{ marginTop: 20 }} defaultChecked={selectedTeamMember.settings.hide_from_members_page} onChecked={(checked) => {
                            setSelectedTeamMember({ ...selectedTeamMember, settings: { ...selectedTeamMember.settings, hide_from_members_page: checked } });
                        }} />
                        <Checkbox scheme={Schemes.OMNEHOST} label={labels.member.show_profile_link} style={{ marginTop: 20 }} defaultChecked={selectedTeamMember.settings.show_link_to_profile} onChecked={(checked) => {
                            setSelectedTeamMember({ ...selectedTeamMember, settings: { ...selectedTeamMember.settings, show_link_to_profile: checked } });
                        }} />
                        <Checkbox scheme={Schemes.OMNEHOST} label={labels.member.show_recent_achs} style={{ marginTop: 20 }} defaultChecked={selectedTeamMember.settings.show_recent_achievements} onChecked={(checked) => {
                            setSelectedTeamMember({ ...selectedTeamMember, settings: { ...selectedTeamMember.settings, show_recent_achievements: checked } });
                        }} />
                    </div>
                </div>
                <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
                    style={{ marginTop: 100, padding: "10px 25px", alignSelf: "flex-end" }} onClick={(e) => updateTeamMember(selectedTeamMember, e.manageRef)} />
            </div>
        </div>)}
    </div>);

    function renderListing() {
        return (<div className="profile-settings team-settings">
            <Checkbox scheme={Schemes.OMNEHOST} label={labels.enable_ad} defaultChecked={teamWebsite.members_settings.enable_rivtn_ad} onChecked={(checked) => {
                setTeamWebsite({ ...teamWebsite, members_settings: { ...teamWebsite.members_settings, enable_rivtn_ad: checked } });
            }} />
            <Checkbox scheme={Schemes.OMNEHOST} label={labels.show_prev_mems} defaultChecked={teamWebsite.members_settings.show_previous_team_members} onChecked={(checked) => {
                setTeamWebsite({ ...teamWebsite, members_settings: { ...teamWebsite.members_settings, show_previous_team_members: checked } });
            }} />
            <hr style={{ marginBottom: "0.5px" }} />
            <div className="pagination">
                {Elements.buildPaginator(teamMembers ?? {},
                    ({ currentPage }, size) => Utils.updateSearchParamses({ "page": currentPage, size }, setSearchParams, fetchInformation),
                    parseInt(searchParams.get("page") ?? "1"), { margin: 15, marginBottom: 5 })}
                <Checkbox scheme={Schemes.OMNEHOST} label={labels.inc_prev_team_mems} defaultChecked={searchParams.has("inc_prev")} onChecked={(checked) => {
                    Utils.updateSearchParams("inc_prev", (checked ? "true" : undefined), setSearchParams, fetchInformation);
                }} />
            </div>
            <div className="tmembers">
                {!teamMembers.content
                    ? (Elements.LOADING_STATE)
                    : (teamMembers.content?.map((teamMember) => {
                        const isYou = teamMember.external_id === props.profile.external_id && (i18nManager.Labels.host.analytics.earnings.you);

                        return (<div className="tmember" key={teamMember.external_id} onClick={() => {
                            Utils.updateSearchParams("stmid", teamMember.external_id, setSearchParams, () => setSelectedTeamMember(teamMember));
                        }}>
                            {teamMember.status === TeamMemberStatus.ACTIVE && (
                                <i className={Classname.build("fa fa-shoe-prints", { "noseur-disabled": BoolHelper.equalsAny(teamMember.role, [TeamRole.OWNER, TeamRole.MODERATOR]) })} onClick={(e) => {
                                    e.stopPropagation();
                                    kickMember(teamMember);
                                }} />)}
                            {teamMember.status === TeamMemberStatus.KICKED && (<i className="fa-solid fa-user-plus" style={{ color: "var(--mainColor)" }} onClick={(e) => {
                                e.stopPropagation();
                                resendJoinInvite(teamMember);
                            }} />)}
                            <div>
                                <img alt={teamMember.display_name} src={teamMember.passport_picture_url} />
                                <div>
                                    <span className="n">{teamMember.display_name} {isYou ? `(${labels.you})` : ""}</span>
                                    <span className="ta"><span>{labels.role}</span> {teamMember.status === TeamMemberStatus.KICKED ? labels.previous_member : teamMember.display_role}</span>
                                    {teamMember.status === TeamMemberStatus.ACTIVE && (<span className="ta"><span>{labels.joined}</span> {Utils.formatToFineDate(teamMember.join_date ?? "", true, true)}</span>)}
                                    {teamMember.status === TeamMemberStatus.KICKED && (<>
                                        <span className="ta"><span>{labels.first_joined}</span> {Utils.formatToFineDate(teamMember.created_at, true, true)}</span>
                                        <span className="ta"><span>{labels.last_left}</span> {Utils.formatToFineDate(teamMember.created_at, true, true)}</span>
                                    </>)}
                                </div>
                            </div>
                        </div>);
                    }))}
            </div>
        </div>);
    }

    function fetchInformation() {
        setTeamMembers({});
        teamService.queryTeamMembers(props.team.external_id, {
            page: parseInt(searchParams.get("page") ?? "1"),
            size: parseInt(searchParams.get("size") ?? "10"),
            //status: (searchParams.has("inc_prev") ? "ACTIVE,KICKED" : "ACTIVE").split(","), // faulty in kyofuuc
        }).then(({ apiResponse }: SanitizedResponse<ITeamMember>) => {
            setTeamMembers(apiResponse.data!);
            for (const tm of apiResponse.data!.content ?? []) {
                if (tm.external_id === searchParams.get("stmid")) {
                    setSelectedTeamMember(tm);
                    break;
                }
            }
        }).catch(BaseService.reportError);
    }

    function updateTeamMember(teamMember: ITeamMember, manageRef?: ButtonManageRef) {
        manageRef?.setLoadingState(true);
        teamService.updateTeamMember(teamMember).then(({ sanitized }: SanitizedResponse<any>) => {
            Siren.alert(labels.update_success);
        }).catch(BaseService.reportError).finally(() => manageRef?.setLoadingState(false));
    }

    function updateTeamWebsite() {
        teamService.updateTeamWebsite(team.external_id, { ...teamWebsite }).then(({ }: SanitizedResponse<ITeamWebsite>) => {
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError);
    }

    function kickMember(teamMember: ITeamMember) {
        let memberName = "";
        const dialogLabels = labels.dialog.kick;
        const dialogErrorRef = { current: null } as any;

        const dialog = ConfirmDialog({
            closable: true,
            title: dialogLabels.title,
            confirmScheme: Scheme.DANGER,
            confirmLabel: dialogLabels.give_the_boot,
            desc: dialogLabels.desc.replace("${team_name}", props.team.name).replace("${member_name}", teamMember.display_name),
            content: (<div style={{ margin: "10px 0px" }}>
                <FormControl style={{ marginTop: 15 }} isFieldset fill label={dialogLabels.mems_name}>
                    <TextInput onInputComplete={(v) => {
                        dialogErrorRef.current!.innerText = " ";
                        memberName = v;
                    }} />
                </FormControl>
                <div ref={dialogErrorRef} className="error"> </div>
            </div>),
            onConfirm: async (button?: ButtonManageRef) => {
                if (memberName !== teamMember.display_name) {
                    dialogErrorRef.current!.innerText = i18nManager.Labels.teams.dialog.confirm_team.mem_name_does_not_match;
                    return false;
                }
                button?.setLoadingState(true);
                teamService.kickTeamMember(teamMember.external_id).then(({ }: SanitizedResponse<any>) => {
                    dialog.hide(() => {
                        fetchInformation();
                        Siren.alert(dialogLabels.remove_successful);
                    });
                }).catch(({ errorMessage }: any) => {
                    dialogErrorRef.current!.innerText = errorMessage;
                    button?.setLoadingState(false);
                });
                return false;
            }
        });
        dialog.show();
    }

    function resendJoinInvite(teamMember: ITeamMember) {
        ConfirmDialog({
            onLoading: async (alert) => {
                teamService.inviteTeamMember({
                    team_id: team.external_id,
                    note: null as any as string,
                    expiry_date: null as any as string,
                    member_username: teamMember.member?.username,
                }).then(({ }: SanitizedResponse<any>) => {
                    Siren.alert(labels.re_invite_successfully_sent.replace("${username}", teamMember.member?.username ?? ""));
                }).catch(BaseService.reportError).finally(alert.hide);
                return false;
            }
        }).show();
    }

}

export default Members;
